import { Rooms } from '../types/bingo-events/in/chat/join';

export const useCurrentRoom = (rooms: Rooms[], currentRoomId: number) => {
    const [currentRoom] = rooms
        .filter((room) => room.id === currentRoomId)
        .map((room) => room.name);

    return currentRoom;
};
